import { Localized } from '../../../../../../shared/type';
import { FundingSortOptions, FundingSortStrategies } from '@services/MarppleShop/features/Funding';
import z from 'zod';
import { ProductThumbnail } from '@services/MarppleShop/features/ProductList/type';

export interface FundingItem {
  productId: number;
  domainName: string;
  name: Localized<string>;
  description?: string;
  thumbnailInfo: ProductThumbnail;
  goalAmount: number;
  totalAmount: number;
  sellStartAt?: Date;
  sellEndAt?: Date;
  isForceOutOfStock?: boolean;
  isQuantityPublic?: boolean;
  isPublic?: boolean;
  outOfStock?: boolean;
  quantity?: number;
  orderCount?: number;
}

export interface FundingListResponse {
  data: FundingItem[];
  totalCount: number;
}

export interface FundingFilterOptions {
  productIds?: number[];
  storeIds?: number[];

  /**
   *  펀딩 정렬 상태를 정의합니다.
   *
   *  [FundingCompositeSortStrategy.InProgress, FundingCompositeSortStrategy.ComingSoon, FundingCompositeSortStrategy.End]
   *  진행중 -> 공개예정 -> 종료
   *
   *  [FundingCompositeSortStrategy.ComingSoon, FundingCompositeSortStrategy.End]
   *  공개예정 -> 종료
   *
   *  [FundingCompositeSortStrategy.InProgress]
   *  진행중
   */
  strategies?: FundingSortStrategies;

  /**
   * 각 펀딩 정렬 상태의 조건을 디테일하게 정의합니다.
   *
   * in_progress: FundingCompositeSortStrategy.InProgress.buildDeadlineSort (진행중 상태는 마감 임박순 정렬)
   */
  sort?: FundingSortOptions;

  limit?: number;
  offset?: number;
}

export interface FundingExistOptions {
  productIds?: number[];
  storeId?: number;
}

export const GetFundingListParamsSchema = z.object({
  page: z.coerce.number().optional(),
  limit: z.coerce.number().optional(),
});

export const FundingListFetchOptionValidator = GetFundingListParamsSchema.transform((data) => {
  return {
    page: data.page ? Number(data.page) : 1,
    limit: data.limit ? Number(data.limit) : 60,
    offset: 60 * Math.max((data.page || 0) - 1, 0),
  };
});

export type FundingListFetchOption = z.infer<typeof FundingListFetchOptionValidator>;
